<template>
  <div class="CustomerCareActions">
    <transition name="fade" mode="out-in">
      <app-loading
        v-if="isLoading"
        :is-loading="isLoading"
        :size="30"
      />
    </transition>

    <template v-if="!isLoading">
      <div class="CustomerCareActions_body">
        <p
          class="result"
          v-if="currentActionResult.message"
          :class="{ 'error': this.currentActionResult.type === 'error'}"
        >
          {{ currentActionResult.message }}
        </p>

        <app-select
          v-model="selectedAction"
          :placeholder="$t('subscription_details.customerCareActions.selectAction', 'Select a customer care action')"
          :options="ifBCBS || normalizedCustomerCareActions || []"
          :searchable="false"
          :allow-empty="false"
          :show-labels="false"
          open-direction="bottom"
          label="description"
          track-by="type"
          :disabled="customerCareActionTask.isActive"
        >
          <span slot="noOptions">{{ $t('subscription_details.customerCareActions.select.noOptions', 'This subsciption has no executable action') }}</span>
        </app-select>

        <app-text-input
          v-if="selectedAction && selectedAction.type === 'GiveDiscountToNextPayment'"
          class="Form_group-amount-discount"
          :label="$t('subscription_details.customerCareActions.lable.amount', 'Amount')"
          v-model.trim="discountAmount"
          :errors="errorsFor('discountAmount')"
          :disabled="customerCareActionTask.isActive"
          data-name="customerCareAction-discountAmount"
        />

        <app-text-input
          v-if="selectedAction && (selectedAction.type === 'ReturnAfterRightToReturnDayButNotCustomerFault' || selectedAction.type === 'ReturnTryBuyAfterRightToReturnDayButNotCustomerFault' || selectedAction.type === 'ReturnReplenishmentAfterRightToReturnDayButNotCustomerFault')"
          class="Form_group-amount-discount"
          :label="$t('subscription_details.customerCareActions.lable.cancellationDate', 'Cancellation Date')"
          :placeholder="$t('subscription_details.customerCareActions.placeholder', 'YYYY-MM-DD')"
          v-model.trim="cancellationDate"
          :errors="errorsFor('cancellationDate')"
          :disabled="customerCareActionTask.isActive"
          data-name="customerCareAction-cancellationDate"
        />
      </div>

      <app-button
        type="submit"
        class="button-widthAuto"
        :disabled="disabledSubmit"
        @click.prevent="startCustomerCareAction()"
      >
        {{ $t('subscription_details.accordion.customerCareActions.button.submit', 'Submit') }} ›
      </app-button>

      <app-modal name="customerCareAction" width="500">
        <div class="v--modal-content">
          <h3 class="modal-title">
            {{ $t('subscription_details.customerCareActions.confirmationModal.title', 'Customer Care Action') }}
          </h3>

          <div class="modal-content" v-if="selectedAction">
            <p v-if="(selectedAction.type === 'Reshipping') && (selectedAction.extraData.hasReship)">
              {{ $t('subscription_details.customerCareActions.reshipping.confirmationModal.text', 'This subscription already contains a re-shipping amendment - are you sure you want to proceed?') }}
            </p>

            <p v-else>
              {{ $t('subscription_details.customerCareActions.confirmationModal.text', 'Are you sure you want to do this Action?') }}
            </p>

            <div class="modal-button-warpper">
              <app-button
                type="submit"
                @click.prevent="customerCareActionTask.run()"
                :is-loading="customerCareActionTask.isActive"
              >
                {{ $t('subscription_details.customerCareActions.confirmationModal.button.ok', 'Ok') }}
              </app-button>

              <app-button @click="$bus.$emit('close-modal', 'customerCareAction')">
                {{ $t('subscription_details.customerCareActions.confirmationModal.button.cancel', 'Cancel') }}
              </app-button>
            </div>
          </div>
        </div>
      </app-modal>
      <app-modal name="reshippingAction" width="500" @after-closed="emptyResumeOptions">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="reshipping_options">
              <app-checkbox
                v-for="(item, index) in reshippingOptions"
                :key="index"
                :id="item.id"
                :label="item.text"
                @input="item.checked = $event"
                :value="item.checked"
              />
            </div>
            <div class="modal-button-warpper">
              <app-button
                type="submit"
                @click.prevent="reshippingTask.run()"
                :is-loading="reshippingTask.isActive"
                :disabled="!triggerReshipingRatePlans"
              >
                {{ $t('subscription_details.customerCareActions.confirmationModal.button.ok', 'Ok') }}
              </app-button>

              <app-button @click="cancelReshipping()">
                {{ $t('subscription_details.customerCareActions.confirmationModal.button.cancel', 'Cancel') }}
              </app-button>
            </div>
          </div>
        </div>
      </app-modal>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { getErrors, extractErrorMessage } from '@/utilities/common'
  import { required, decimal } from 'vuelidate/lib/validators'
  import { format } from 'date-fns'
  import { detectedCulture } from '@/utilities/common/culture'
  import { mapState } from 'vuex'
  // import { find, startsWith } from 'lodash'

  export default {
    name: 'subscription-customer-care-actions',

    data () {
      return {
        isLoading: true,
        subscribeNumber: this.$route.params.id,
        customerCareActions: [],
        selectedAction: null,
        currentActionResult: {},
        discountAmount: null,
        cancellationDate: format(new Date(), 'YYYY-MM-DD'),
        reshippingOptions: [],
        actionReshipTryBuy: null,
        actionReshipReplenishment: null,
        currentCountryCode: detectedCulture.countryCode
      }
    },

    props: {
      tryBuy: {
        type: Object,
        default: null
      },
      replenishment: {
        type: Object,
        default: null
      }
    },

    computed: {
      ...mapState('subscription', ['subscriptionDetails']),
      normalizedCustomerCareActions () {
        return this.customerCareActions && this.customerCareActions.map(action => {
          let actionItem = {}
          actionItem.type = action.name
          actionItem.description = this.$t(`subscription_details.accordion.customerCareActions.action.${action.name}`, `${action.name}`)
          actionItem.extraData = action.extraData
          return actionItem
        })
      },

      disabledSubmit () {
        if (!this.selectedAction) {
          return true
        } else if (this.selectedAction.type === 'GiveDiscountToNextPayment' && this.$v.discountAmount.$invalid) {
          return true
        } else if (this.selectedAction.type === 'ReturnAfterRightToReturnDayButNotCustomerFault' && this.$v.cancellationDate.$invalid) {
          return true
        } else {
          return false
        }
      },

      normalizedCancellationDate () {
        return new Date(this.cancellationDate).toDateString()
      },

      triggerReshipingRatePlans () {
        let optionSelected = ''
        this.reshippingOptions.map(reshippingOption => {
          if (reshippingOption.checked) {
            optionSelected = optionSelected + reshippingOption.id + ';'
          }
        })
        if (optionSelected.indexOf('TryBuy') !== -1 && optionSelected.indexOf('Replenishment') !== -1) {
          return 'Both'
        } else if (optionSelected.indexOf('Replenishment') !== -1) {
          return 'Replenishment'
        } else if (optionSelected.indexOf('TryBuy') !== -1) {
          return 'TryBuy'
        }
      },

         ifBCBS: function () { 
            if(this.currentCountryCode === 'US' && this.subscriptionDetails.isBCBSSubscription == true ){
              return this.normalizedCustomerCareActions.filter(function (normalizedCustomerCareActions) {return normalizedCustomerCareActions.description == 'Trigger re-shipping'}) 
            } 
          },
    },

    validations: {
      discountAmount: {
        required,
        decimal
      },

      cancellationDate: {
        required,
        dateFormat (value) {
          return /^([1-2]\d{3})[-](0?[1-9]|10|11|12)[-]([1-2]?[0-9]|0[1-9]|30|31)$/.test(value)
        }
      }
    },

    methods: {
      actionSuccess () {
        this.currentActionResult = {
          type: 'success',
          message: this.$t('subscription_details.customerCareActions.action.execute.success', 'this action has been executed successfully')
        }
      },

      errorsFor (field) {
        return getErrors(this.$v[field])
      },

      canDoReshippingRateplans () {
        if (this.actionReshipTryBuy && this.actionReshipTryBuy.enabled && this.actionReshipReplenishment && this.actionReshipReplenishment.enabled) {
          return [
            {
              text: this.$t('subscription_details.adminActions.reshipping.replenishment.text', { replenishment: this.replenishment && this.replenishment.name }),
              checked: false,
              id: 'Replenishment'
            },
            {
              text: this.$t('subscription_details.adminActions.reshipping.trybuy.text', { trybuy: this.tryBuy && this.tryBuy.name }),
              checked: false,
              id: 'TryBuy'
            }
          ]
        } else if (this.actionReshipTryBuy && this.actionReshipTryBuy.enabled && this.actionReshipReplenishment && !this.actionReshipReplenishment.enabled) {
          return [
            {
              text: this.$t('subscription_details.adminActions.reshipping.trybuy.text', { trybuy: this.tryBuy && this.tryBuy.name }),
              checked: false,
              id: 'TryBuy'
            }
          ]
        } else if (this.actionReshipTryBuy && !this.actionReshipTryBuy.enabled && this.actionReshipReplenishment && this.actionReshipReplenishment.enabled) {
          return [
            {
              text: this.$t('subscription_details.adminActions.reshipping.replenishment.text', { replenishment: this.replenishment && this.replenishment.name }),
              checked: false,
              id: 'Replenishment'
            }
          ]
        } else {
          return []
        }
      },

      startCustomerCareAction () {
        if (this.selectedAction && this.selectedAction.type === 'Reshipping' && !this.selectedAction.extraData.hasReship) {
          this.$bus.$emit('open-modal', 'reshippingAction')
        } else {
          this.$bus.$emit('open-modal', 'customerCareAction')
        }
      },

      cancelReshipping () {
        this.$bus.$emit('close-modal', 'reshippingAction')
        this.reshippingOptions = this.canDoReshippingRateplans()
      },

      emptyResumeOptions () {
        this.reshippingOptions = this.canDoReshippingRateplans()
      },

      getAdminAction () {
        Vue.api.admin.getAdminActions(this.$route.params.id).then(adminActions => {
          this.isLoading = false
          const actions = adminActions.filter(action => !action.name.startsWith('Reship'))
          this.actionReshipTryBuy = adminActions.find(action => action.name === 'ReshipTryBuy')
          this.actionReshipReplenishment = adminActions.find(action => action.name === 'ReshipReplenishment')
          const reshipAction = {
            name: 'Reshipping',
            enabled: (this.actionReshipTryBuy && this.actionReshipTryBuy.enabled) || (this.actionReshipReplenishment && this.actionReshipReplenishment.enabled),
            extraData: {
              hasReship: (this.actionReshipTryBuy && this.actionReshipTryBuy.extraData) || (this.actionReshipReplenishment && this.actionReshipReplenishment.extraData)
            }
          }
          actions.push(reshipAction)
          this.customerCareActions = actions.filter(action => action.enabled)
          this.reshippingOptions = this.canDoReshippingRateplans()
        }).catch(error => {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(error)
          })
        })
      }
    },

    tasks (t) {
      return {
        customerCareActionTask: t(async function () {
          this.$bus.$emit('close-modal', 'reshippingAction')
          this.currentActionResult = {}
          switch (this.selectedAction.type) {
            case 'ReturnWithinRightToReturnDay':
              if (this.subscriptionDetails.contentProductName === 'Lumea' && this.currentCountryCode === 'GB') {
                await Vue.api.admin.cancellationSubscriptiontrybuywithin(this.subscriptionDetails.number)
              } else {
                await Vue.api.admin.returnWithinRightToReturnDay(this.subscribeNumber)
              }
              this.actionSuccess()
              break
            case 'ReturnTryBuyWithinRightToReturnDay':
              await Vue.api.admin.tryBuyReturnWithinRightToReturnDay(this.subscribeNumber)
              this.actionSuccess()

              break
            case 'ReturnReplenishmentWithinRightToReturnDay':
              await Vue.api.admin.replenishmentReturnWithinRightToReturnDay(this.subscribeNumber)
              this.actionSuccess()

              break
            case 'ReturnAfterRightToReturnDay':
              if (this.subscriptionDetails.contentProductName === 'Lumea' && this.currentCountryCode === 'GB') {
                await Vue.api.admin.cancellationSubscriptiontrybuyafter(this.subscriptionDetails.number)
              } else {
                await Vue.api.admin.returnAfterRightToReturnDay(this.subscribeNumber)
              }
              this.actionSuccess()
              break
            case 'ReturnTryBuyAfterRightToReturnDay':
                  await Vue.api.admin.tryBuyReturnAfterRightToReturnDay(this.subscribeNumber)
              this.actionSuccess()
              break
            case 'ReturnAfterRightToReturnDayButNotCustomerFault':
              await Vue.api.admin.returnAfterRightToReturnDayButNotCustomerFault(this.subscribeNumber, this.cancellationDate)
              this.actionSuccess()
              break
            case 'ReturnTryBuyAfterRightToReturnDayButNotCustomerFault':
              await Vue.api.admin.tryBuyReturnAfterRightToReturnDayButNotCustomerFault(this.subscribeNumber, this.cancellationDate)
              this.actionSuccess()
              break
            case 'ReturnReplenishmentAfterRightToReturnDayButNotCustomerFault':
              await Vue.api.admin.replenishmentReturnAfterRightToReturnDayButNotCustomerFault(this.subscribeNumber, this.cancellationDate)
              this.actionSuccess()
              break
            case 'GiveDiscountToNextPayment':
              await Vue.api.admin.giveDiscountToNextPayment(this.subscribeNumber, this.discountAmount)
              this.actionSuccess()
              break
            case 'Reshipping':
              this.$bus.$emit('open-modal', 'reshippingAction')
              break
          }
          this.$bus.$emit('close-modal', 'customerCareAction')
          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscribeNumber)
          await this.getAdminAction()
          this.selectedAction = null
        }).onError(function (task) {
          if (this.selectedAction.type === 'Reshipping') {
            this.currentActionResult = {
              type: 'error',
              message: this.$t('subscription_details.customerCareActions.action.reshipping.fail', 're-shipping rate plan not applied')
            }
          } else {
            this.currentActionResult = {
              type: 'error',
              message: extractErrorMessage(task.error)
            }
          }
        }),

        reshippingTask: t(async function () {
          await Vue.api.admin.Reshipping(this.subscribeNumber, { option: this.triggerReshipingRatePlans })
          this.currentActionResult = {
            type: 'success',
            message: this.$t('subscription_details.customerCareActions.action.reshipping.success', 're-shipping rate plan successfully applied')
          }
          this.$bus.$emit('close-modal', 'reshippingAction')
          window.location.reload()
        }).onError(function (task) {
          this.currentActionResult = {
            type: 'error',
            message: this.$t('subscription_details.customerCareActions.action.reshipping.fail', 're-shipping rate plan not applied')
          }
        })
      }
    },

    created () {
      this.getAdminAction()
    }
  }
</script>

<style lang="scss">
  .CustomerCareActions {
    position: relative;
    min-height: .3rem;

    &_body {
      margin-bottom: .1rem;

      .result {
        color: $success;
        margin-bottom: .1rem;

        &.error {
          color: $error-color;
        }
      }

      .multiselect {
        &__tags {
          border: .02rem solid $blue;
        }

        &__content-wrapper {
          border-width: 0 .02rem .02rem;
          border-style: solid;
          border-color: $blue;
        }

        &__option {
          white-space: pre-wrap;
          word-break: break-all;
        }
      }

      .Form_group-amount-discount {
        margin-top: .1rem;
        margin-bottom: 0;

        .Form_label {
          display: inline-block;
          font-weight: 500;
          font-size: .17rem;
          color: $blue;
          margin-bottom: .05rem;
        }

        .Form_control {
          border: 0.02rem solid #0066a1;
          padding: .04rem .1rem;
        }

        .tip-error {
          padding: .05rem 0;
        }
      }

      .AppDatePicker {
        margin-top: .1rem;

        .title-date {
          font-weight: 500;
          font-size: .17rem;
          color: $blue;
        }
      }
    }

    .AppButton {
      min-width: 1.86rem;
    }

    .reshipping_options {
      margin-top: .2rem;

      .AppCheckbox {
        &_label {
          border-radius: 50%;
        }
      }

      .Form_label {
        font-size: .16rem;
        color: #666;
        font-weight: 400;
        line-height: .2rem;
      }
    }
  }
</style>
